import * as dashboard        from './dashboard';

export default ({
  dashboard
});